import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import { change, Field, formValueSelector, getFormValues, reduxForm, reset } from 'redux-form';

import { showErrorMessage, showFormatedDate, showNormalizedRate, VIP } from '../../../../actions/utilAction';
import { updateClientPaymentStatus } from './actions/index';
import { renderAutoCompleteSingleSelect, renderCheckBox } from '../../../../components/reduxFields';
import SortingCustom from '../../../../components/SortingCustom';
import UpdateBatchClaimPaymentStatusModal from './UpdateBatchClaimPaymentStatusModal';
import ClaimInternalNotesModal from './../manageClaims/ClaimInternalNotes_Modal';
import AddNoteModal from '../manageClaims/AddNoteModal';
import CliamHistoryModal from '../manageClaims/CliamHistoryModal';
import Tooltip from '../../../../components/Tooltip';
import history from '../../../../history';
import PaginatorCustom from '../../../../components/paginationCustom';
import UpdateBatchClaimOfficeallyStatusModal from './UpdateBatchClaimOfficeallyStatusModal';
import BulkUpdateWriteOffDateModal from '../manageClaims/BulkUpdateWriteOffDateModal';

class ClaimsDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      selectedLedgerClaimIds: [],
      openModal: false,
      openInternalNotesModal: false,
      ClaimId: null,
      isAddNoteModalOpen: false,
      isOpenBulkUpdateWriteOffDate:false,
      openClaimHistoryModal: false,
      openOfficeallyStatusModal: false,
    }
    this.handleNewRequest = this.handleNewRequest.bind(this);
  }

  handleClose = () => {
    this.setState({
      openModal: false,
      selectedLedgerClaimIds: [],
      openInternalNotesModal: false,
      isAddNoteModalOpen: false,
      isOpenBulkUpdateWriteOffDate:false,
      openOfficeallyStatusModal: false
    });
    // this.props.loadClaimsData();
    this.props.handleReset();
    this.props.dispatch(reset('ClaimDetailForm', 'Chkclaim', null))
  }

  closeDialog = () => {
    (this.state.selectedLedgerClaimIds || []).forEach((obj, claimIndex) => {
      this.props.dispatch(change('ClaimDetailForm', `Claims[${claimIndex}].Chk`, null));
    });
    this.setState({
      openModal: false,
      selectedLedgerClaimIds: [],
      openInternalNotesModal: false,
      isAddNoteModalOpen: false,
      isOpenBulkUpdateWriteOffDate:false,
      openOfficeallyStatusModal: false
    },
    ()=>this.props.dispatch(change('ClaimDetailForm', 'Chkclaim', null)));       
  }

  handleNewRequest(input, selectedValue, claimId) {
    input.onChange(selectedValue.value);
    this.props.updateClientPaymentStatus(claimId, selectedValue.value || null);    
  }

  componentWillReceiveProps(nextProps) { 
    if (nextProps.ledgerDetails.data && nextProps.ledgerDetails.data !== this.props.ledgerDetails.data) {
      (nextProps.ledgerDetails.data || []).forEach((obj, claimIndex) => {
        this.props.dispatch(change('ClaimDetailForm', `Claims[${claimIndex}].claimPaymentStatusId`, obj.claimPaymentStatusId || null));
      });
    }
    
    if (nextProps.paymentStatus_updated && nextProps.paymentStatus_updated.message !== this.props.paymentStatus_updated.message) {
      this.closeDialog();
      this.props.loadClaimsData();
    }
  }

  checkAllLedgerBatchClaims = (e, claimId) => {
    let isAllLedgerChecked = e.target.checked,
      ledgerData = this.props.ledgerDetails.data;
    let selectedLedgerClaimIds = [];
    ledgerData.forEach((obj, claimIndex) => {
      let claimIdCheck = `Claims[${claimIndex}].Chk`;
      if (obj && isAllLedgerChecked) {
        selectedLedgerClaimIds.push(obj.claimId);
        this.props.dispatch(change('ClaimDetailForm', claimIdCheck, true));
      } else {
        this.props.dispatch(change('ClaimDetailForm', claimIdCheck, false));
      }
    });
    this.setState({ selectedLedgerClaimIds });
  }

  CheckLedgerBatchClaim = (e, index, data) => {
    let selectedLedgerClaimIds = this.state.selectedLedgerClaimIds;

    let isLedgerClaimChecked = e.target.checked;
    if (isLedgerClaimChecked) {
      selectedLedgerClaimIds.push(data.claimId);
    } else {
        index = selectedLedgerClaimIds.findIndex((value) => value === data.claimId);
        if (index >= 0) {
          selectedLedgerClaimIds.splice(index, 1);
        }
    }
    this.setState({ selectedLedgerClaimIds });
  }

  _IsEveryClosedOrWriteOffValidFromArr(arr = []){
    let statusMime = {
        closed: 121,
        writeoff: 138 
    };

    let flag = arr.every(claim => {
        return (statusMime.closed === claim.claimPaymentStatusId || statusMime.writeoff === claim.claimPaymentStatusId)
    })
    return flag;
  }

  handleOpenInternalNotes = (event, obj) => {
    // console.log('event, claimId.........', obj)
    this.setState({ openInternalNotesModal: true, ClaimId: obj.claimId });
  };

  handleOpenHistory = (event, claimId) => {
    // this.setState({ ClaimId: claimId });
    // this.props.handleClaimIdTabChange('5', claimId);
    // this.props.handleClaimTabChange('4');
    this.setState({
      openClaimHistoryModal: true,
      ClaimId: claimId
    });
  }

  handleCloseClaimHistoryModal = () => {
    this.setState({
      openClaimHistoryModal: false
    });
  }
  
  handleViewEDIResponseClick=(event, obj) => {    
      history.push(`/claims/${obj.claimId}`);
  };
    
  renderData = () => {
    const claimPaymentStatus = {
      closed: 121,
      writeoff: 138 
    };
  
    const {
      ledgerDetails,
      handleViewClick,
    } = this.props;

    let ledgerData = ledgerDetails && ledgerDetails.data,
      ledgerArray = ledgerData || [];

    if (!ledgerArray.length) {
      return (
        <tr><td colSpan="19" className="text-center no-record">No record found.</td></tr>
      );
    }
    return ledgerArray.map((Obj, index) => {
      let minServiceLineDate  = showFormatedDate(Obj.minServiceLineDOS);
      let maxServiceLineDate = showFormatedDate(Obj.maxServiceLineDOS);
      let isSameMinMaxDate = minServiceLineDate === maxServiceLineDate;
      let date = Obj.dos === "1990-01-01T00:00:00"
      return (
        <tr key={index}>
          <td>
            <Field
              name={`Claims[${index}].Chk`}
              component={renderCheckBox}
              onChange={(e) => this.CheckLedgerBatchClaim(e, index, Obj)}
            />
          </td>
          <td>
            <span>{Obj.claimId ? <Tooltip Description={Obj.xmlString} /> : null}{`CL${Obj.claimId}`}</span>
          </td>
          <td>{Obj.cl837Ids != "" ? <Tooltip Description={Obj.cl837Ids} /> : null}{date ? 
            (isSameMinMaxDate ? showFormatedDate(Obj.minServiceLineDOS) : (showFormatedDate(Obj.minServiceLineDOS) + ' - ' + showFormatedDate(Obj.maxServiceLineDOS))) : 
            (showFormatedDate(Obj.dos))}
          </td>
          <td>{Obj.patientName ? Obj.patientName : '-'}</td>          
          <td>{showNormalizedRate(Obj.totalAmount || 0)}</td>
          <td>{showNormalizedRate(Obj.allowedAmount || 0)}</td>
          <td>{showNormalizedRate(Obj.insuranceOwes || 0)}</td>
          <td>{showNormalizedRate(Obj.insurancePayments || 0)}</td>
          <td>{showNormalizedRate(Obj.insuranceAdjustments || 0)}</td>
          <td>{showNormalizedRate(Obj.interestPayment || 0)}</td>
          <td>{showNormalizedRate(Obj.patientOwes || 0)}</td>
          <td>{showNormalizedRate(Obj.patientPayments || 0)}</td>
          <td>{showNormalizedRate(Obj.balanceWithoutAdjustment || 0)}</td>
          <td>{showNormalizedRate(Obj.balanceWithAdjustment || 0)}</td>
          <td>{showNormalizedRate(Obj.allowedBalance || 0)}</td>
          {Obj.claimOfficeallyStatus ?
              (Obj.claimOfficeallyStatus === 'Accepted by OA' || Obj.claimOfficeallyStatus === 'Received by OA' || Obj.claimOfficeallyStatus === 'Accepted by Payer') ?
                <td style={{ color: '#2bd30d' }}>{Obj.claimOfficeallyStatus}</td>
                : <td style={{ color: '#e11717' }}>{Obj.claimOfficeallyStatus}</td>
            : <td>{'-'}</td> }
          <td>{Obj.numberOfDayOutstanding}</td>
          <td>
            <Field
              name={`Claims[${index}].claimPaymentStatusId`}
              hintText="Status"
              handleNewRequest={(input, selectedValue) => this.handleNewRequest(input, selectedValue, Obj.claimId)}
              options={this.props.masterClaimPaymentStatus}
              className="ClsPaymentLedgerListing"
              component={renderAutoCompleteSingleSelect}
            />
          </td>
         
          <td>{(Obj.claimPaymentStatusId  === claimPaymentStatus.closed || Obj.claimPaymentStatusId  === claimPaymentStatus.writeoff) ? (((Obj.closeOrWriteOffDate !== null) && (Obj.closeOrWriteOffDate !== undefined)) &&
          showFormatedDate(Obj.closeOrWriteOffDate) ) : " "}</td>
          <td>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <button style={{margin: 0 }} onClick={(e) => handleViewClick(e, Obj)} type="button" title="View Ledger" className="tbactionbtn yellowfont"><i className="fa fa-eye" aria-hidden="true"></i></button>
              <button style={{margin: 0 }} onClick={(e) => this.handleOpenHistory(e, Obj.claimId)} type="button" title="Claim History" className="tbactionbtn bluefont"><i className="fa fa-history" aria-hidden="true"></i></button>
              <button onClick={(e) => this.handleOpenInternalNotes(e, Obj)} type="button" title="Claim Internal Notes" className="tbactionbtn bluefont"><i className="fa fa-sticky-note-o" aria-hidden="true"></i></button>
              {/* <button onClick={(e) => this.handleViewEDIResponseClick(e, Obj)} type="button" title="View EDI Response" className="tbactionbtn bluefont"><i className="fa fa-eye" aria-hidden="true"></i></button> */}
            </div>
          </td>
        </tr>
      );
    });
  };

  handleUpdateBatchClaimPaymentstatus = (e) => {
    this.setState({
      openModal: true
    });
  }

  handleUpdateBatchClaimOfficeallystatus = (e) => {
    this.setState({
      openOfficeallyStatusModal: true
    });
  }  

  handleAddBulkNoteClick = () => {
    this.setState({
      isAddNoteModalOpen: true
    })
  }

  handleBulkUpdateCloseWriteOffDate = () => {
    if(this.props.ledgerDetails && this.props.ledgerDetails.data && this.props.ledgerDetails.data.length && this.state.selectedLedgerClaimIds && this.state.selectedLedgerClaimIds.length){
      let claims = this.props.ledgerDetails.data;
      let selectedClaims = claims.filter(ins=>{
        return this.state.selectedLedgerClaimIds.includes(ins.claimId);
      });
      let flag = this._IsEveryClosedOrWriteOffValidFromArr(selectedClaims);
      if(flag){
  
        this.setState({
          isOpenBulkUpdateWriteOffDate: true
        })
      }else{
        showErrorMessage('To bulk update closed/write off date, all claims should have status closed or write off');
      }
    }
  }

      


render() {
  const tableClass = classNames({
    'table': true,
    'tablePaymentledger': true,
    'table-striped': this.props.bordered,
    'table-bordered': this.props.bordered,
    'table-hover': true,
    'table-condensed': this.props.condensed,
    'customtable': true,
    'suptable': true,
  });
  return (
    <div>
      <div className="clearfix"></div>    
      <div className="row">
        <div className="col-12 col-sm-12 col-md-12 reset-btn claims_btn">
          <RaisedButton className={this.state.selectedLedgerClaimIds.length > 0 ? "grey_btn mt20" : "grey_btn mt20 reset-disable"}
              disabled={this.state.selectedLedgerClaimIds.length > 0 ? false : true}
              onTouchTap={(e) => this.handleUpdateBatchClaimPaymentstatus(e)} >Update Batch Claim Payment Status </RaisedButton>
          <RaisedButton className={this.state.selectedLedgerClaimIds.length > 0 ? "grey_btn ml_15 mt20" : "grey_btn ml_15 mt20 reset-disable"} disabled={this.state.selectedLedgerClaimIds.length > 0 ? false : true} onTouchTap={(e) => this.handleAddBulkNoteClick(e)} >Add Bulk Note</RaisedButton>
          
          <RaisedButton className={this.state.selectedLedgerClaimIds.length > 0 ? "grey_btn ml_15 mt20" : "grey_btn ml_15 mt20 reset-disable"}
              disabled={this.state.selectedLedgerClaimIds.length > 0 ? false : true}
              onTouchTap={(e) => this.handleUpdateBatchClaimOfficeallystatus(e)} >Update Batch Claim Clearinghouse Status </RaisedButton>
          {this.props.agencyName.toUpperCase() === VIP &&<RaisedButton className={this.state.selectedLedgerClaimIds.length > 0 ? "grey_btn ml_15 mt20" : "grey_btn ml_15 mt20 reset-disable"}
              disabled={this.state.selectedLedgerClaimIds.length > 0 ? false : true}
              onTouchTap={(e) => this.handleBulkUpdateCloseWriteOffDate(e)} >Bulk Update Close/Write Off Date</RaisedButton>}
        </div>
        {/* <div className="col-4 col-sm-4 col-md-4 reset-btn claims_btn">              
            
        </div> */}
      </div>
     {this.state.openInternalNotesModal ? <ClaimInternalNotesModal claimId={this.state.ClaimId} closeDialog={this.closeDialog} /> : null}
     {this.state.isAddNoteModalOpen ? <AddNoteModal ClaimId={this.state.ClaimId} PatientId={this.state.PatientId}  closeDialog={this.closeDialog} claimIds={this.state.selectedLedgerClaimIds}/> : null}
     {this.state.openClaimHistoryModal ? <CliamHistoryModal claimHistoryId={this.state.ClaimId}  PatientId={this.state.PatientId}  closeDialog={() => this.handleCloseClaimHistoryModal()}/> : null}
     {this.state.isOpenBulkUpdateWriteOffDate ? <BulkUpdateWriteOffDateModal claimDetailsclaims={this.props.claimDetailsclaims} claimIds={this.state.selectedLedgerClaimIds} closeDialog={this.closeDialog} searchObj={this.props.searchObj} /> : null}
    <div className="table-responsive mt-15">
      <table className={tableClass}>
        <thead>
          <tr>
              <th width="3%">
                <div style={{ marginTop: '20px' }}>
                <Field
                  name='Chkclaim'
                  component={renderCheckBox}
                  onChange={(e) => this.checkAllLedgerBatchClaims(e, this.props.ledgerDetails.data.claimId)}
                />
                <span>&nbsp;</span>
                </div>
              </th>
            <th width="8%"><SortingCustom setSortColumn={this.props.setSortColumn} columnName='claimId' displayName='CL.#'/></th>
            <th width="8%"><SortingCustom setSortColumn={this.props.setSortColumn} columnName='dos' displayName='DOS' /></th>
            <th width="9%">Client</th>
            <th width="4%"><SortingCustom setSortColumn={this.props.setSortColumn} columnName='totalAmount' displayName='Total Amt.($)'/></th>
            <th width="4%">Allowed Amt.</th>
            <th width="4%">Ins. Owes($)</th>
            <th width="4%">Ins. Paid($)</th>
            <th width="4%">Ins. Adj($)</th>
            <th width="4%">Int. Amt.($)</th>
            <th width="4%">Pat. Owes($)</th>
            <th width="4%">Pat. Paid($)</th>
            <th width="5%"><SortingCustom setSortColumn={this.props.setSortColumn} columnName='balanceWithoutAdjustment' displayName='Bal.W/out Adjust.($)'/></th>
            <th width="5%"><SortingCustom setSortColumn={this.props.setSortColumn} columnName='balanceWithAdjustment' displayName='Bal.W/ Adjust.($)'/></th>
            <th width="4%">Allowed Bal.</th>
            <th width="8%">Clearinghouse Status</th>
            <th width="6%"># Of Day Out.</th>
            <th width="17%">Payment Status</th>
            <th width="17%">Close/Write off date</th>
            <th width="3%">Action</th>
          </tr>
        </thead>
        <tbody>
          {this.renderData()}
        </tbody>
      </table>
      {this.props.ledgerDetails.data && this.props.ledgerDetails.meta && this.props.ledgerDetails.meta['totalPages'] && this.props.ledgerDetails.meta['totalPages'] > 1 ?
        <PaginatorCustom data={this.props.ledgerDetails.meta} handlePageChange={(pageNumber) => this.props.loadClaimsData(pageNumber)} />
        : null}
    </div>
    {
      this.state.openModal === true && <UpdateBatchClaimPaymentStatusModal
      selectedLedgerClaimIds={this.state.selectedLedgerClaimIds}
      masterClaimPaymentStatus={this.props.masterClaimPaymentStatus}
      closeDialog={this.closeDialog}
      searchObj={this.props.searchObj}
      />
    }

    {
      this.state.openOfficeallyStatusModal === true && <UpdateBatchClaimOfficeallyStatusModal
      selectedLedgerClaimIds={this.state.selectedLedgerClaimIds}
      masterClaimOfficeallyStatus={this.props.masterClaimOfficeallyStatus}
      closeDialog={this.closeDialog}
      searchObj={this.props.searchObj}
      />
    }


    </div>
  );
}
}

ClaimsDetail = reduxForm({
  form: 'ClaimDetailForm',
})(ClaimsDetail);


const selector = formValueSelector('ClaimDetailForm');

function mapStateToProps(state, ownProps) {
  const claimDetailsclaims = selector(state,'Claims');
  let initialValueData = null;
  if (state.ledger && state.ledger.ledgerDetails && state.ledger.ledgerDetails.data) {    
    initialValueData = {      
      Claims: (state.ledger.ledgerDetails.data || []).map((obj) => {            
        return { 'claimId': obj.claimId, 'claimPaymentStatusId': obj.claimPaymentStatusId};
      }),
    };
  }
  return {
    claimDetailsclaims: claimDetailsclaims,
    initialValues: initialValueData,
    ledgerDetails:state.ledger && state.ledger.ledgerDetails ? state.ledger.ledgerDetails : [],
    paymentStatus_updated:state.ledger && state.ledger.paymentStatus_updated ? state.ledger.paymentStatus_updated : [],
    masterClaimOfficeallyStatus: (state.ledger.masterData && state.ledger.masterData.claimOfficeallyStatus) || [],
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { updateClientPaymentStatus })(ClaimsDetail);


// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/claims.js